/**
 * Game-related translations for Chinese (Traditional) language
 * This file contains translations for game mechanics, stages, and end reasons
 */
export default {
  game: {
    winner: '勝利方',
    evil: '壞人方',
    good: '好人方',
    stage: '階段',
    voteStage: '投票階段',
    voting: '投票',
    excalibur: '神劍',
    'team building': '團隊建立',
    mission: '任務',
    initialization: '初始化',
    'lady of lake': '湖中驗人',
    'check loyalty': '檢查忠誠度',
    'witch loyalty': '女巫的忠誠',
    'announce loyalty': '宣布忠誠',
    'give card': '給卡',
    'lead to victory': '引領勝利',
    'restore honor': '恢復榮譽',
    'king returns': '王者歸來',
    'play card': '打出卡牌',
    'reveal loyalty': '揭示忠誠',
    'we found you': '我們找到你了',
    ambush: '埋伏',
    witch: '巫婆',
    end: '完結',
    lancelots: '蘭斯洛特',
    assassinate: '暗殺',
    hidden: '隱藏',
    historyMode: '記錄階段',
    gameIsEnded: '遊戲結束',
    rolesAndAddons: '角色與插件',
  },
  endReason: {
    manualy: '遊戲已手動完成',
    evilTeamMissions: '壞人方3次任務失敗',
    goodTeamMissions: '好人方3次任務成功',
    missMerlin: '壞人方暗殺梅林失敗',
    missGuinevere: '壞人方暗殺女皇失敗',
    missLovers: '壞人方暗殺戀人失敗',
    missCleric: '邪惡團隊嘗試殺死牧師 + 1 但失敗了',
    killCleric: '邪惡團隊殺死了牧師 + 1',
    killGuinevere: '壞人方暗殺女皇成功',
    killLovers: '壞人方暗殺戀人成功',
    killMerlin: '壞人方暗殺梅林成功',
    rejectedVote: '壞人方破壞了投票',
  },
};
